import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import {
  FaArrowRightLong,
  FaIndianRupeeSign,
  FaRegClock,
} from "react-icons/fa6";
import AboutR from "../assets/images/eventEvent1.jpeg";
import A2 from "../assets/images/eventEvent2.jpeg";
// import A3 from "../assets/images/eventEvent3.jpeg";
import { SlCalender } from "react-icons/sl";
import { IoLocationOutline } from "react-icons/io5";
import CountdownCard from "../components/CountdownCard";
import { useLocation } from "react-router-dom";
import "./styles/test2.styles.css";
import event1 from "../assets/images/Phalguni_Rangarpane/Portrait.jpg";

const Test2 = () => {
  const [event, setEvent] = useState(1);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedEvent = searchParams.get("event");

  useEffect(() => {
    if (selectedEvent) {
      setEvent(selectedEvent);
    }
  }, []);

  function getTimeUntilTargetDate(targetDateString) {
    const now = new Date().getTime();
    const targetDate = new Date(targetDateString).getTime();
    const distance = targetDate - now;

    if (distance < 0) {
      return null;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  }

  const startDate = "2026-05-09T18:00:00";
  const targetDate = "2026-05-09T21:00:00";

  const [timer, setTimer] = useState(getTimeUntilTargetDate(startDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimer(getTimeUntilTargetDate(startDate));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timer]);

  const eventsData = [
    {
      imgUrl: event1,
      eventDate: "9th May 2026",
      eDate: "2026-05-09 18:00:00",
      time: "06:00 PM",
      location: "ADA Rangamandira, Bangalore",
      price: "Free",
      desc: "Phalguni will be presenting her Rangarpane (debut performance) showcasing various unique choreographies from her Guru Smt. Poornima Gururaja. Please join us for an evening of mesmerizing dance and music as Phalguni steps into the next phase of her artistic journey.",
    },
  ];

  // Helper function to get event status
  function getEventStatus(startDateStr, endDateStr) {
    const now = new Date();
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (now < startDate) {
      return 2;
    } else if (now >= startDate && now <= endDate) {
      return 1;
    } else {
      return 0;
    }
  }

  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div
      style={{
        background: "#0E0E0E",
      }}
    >
      <div className="sticky-container">
        <div className="left-1">
          <div className="mt-5">
            <h1
              style={{
                fontFamily: "Oswald",
                color: "#E7E7E7",
              }}
              className="font-weight-bold"
            >
            { getEventStatus(startDate, targetDate) === 2 ?  
              "Upcoming Events" : 
              (getEventStatus(startDate, targetDate) === 1 ? 
              "Ongoing Events" : "Completed Events")}          
            </h1>
            <div
              className="d-flex flex-column mt-5 events-details"
              style={{ fontFamily: "Open Sans" }}
            >
              <div className="d-flex">
                <div
                  style={
                    event == 1
                      ? {
                          color: "#FCB541",
                        }
                      : {
                          color: "white",
                        }
                  }
                >
                  <p
                    className="events-details-p"
                    style={{
                      fontFamily: "Open Sans",
                    }}
                  >
                    09
                  </p>
                  <p
                    className="events-details-d"
                    style={{
                      fontFamily: "Open Sans",
                    }}
                  >
                    May
                  </p>                  
                </div>
                

                <h4
                  className="ms-5 mt-3"
                  onClick={() => setEvent(1)}
                  style={
                    event == 1
                      ? { fontWeight: 700, color: "#FCB541", cursor: "pointer" }
                      : { fontWeight: 500, color: "#F5F5F5", cursor: "pointer" }
                  }
                >
                  Phalguni's Rangarpane <FaArrowRightLong className="ms-3" />
                </h4>
              </div>
{/* -------------next events details------------------ */}
              {/* <div className="d-flex mt-5">
                <div
                  style={
                    event == 2
                      ? {
                          color: "#FCB541",
                        }
                      : {
                          color: "white",
                        }
                  }
                >
                  <p
                    className="events-details-p"
                    style={{
                      fontFamily: "Open Sans",
                    }}
                  >
                    05
                  </p>
                  <p
                    className="events-details-d"
                    style={{
                      fontFamily: "Open Sans",
                    }}
                  >
                    Sep
                  </p>
                </div>
                <h4
                  className="ms-5 mt-3"
                  style={
                    event == 2
                      ? { fontWeight: 700, color: "#FCB541", cursor: "pointer" }
                      : { fontWeight: 500, color: "#F5F5F5", cursor: "pointer" }
                  }
                  onClick={() => setEvent(2)}
                >
                  A.V. Sathanarayana  dance and musical tribute to HSV <FaArrowRightLong className="ms-3" />
                </h4>
              </div> */}

            </div>
          </div>
        </div>
        <div className="right-1">
          <div style={{}}>
            <div className="d-flex justify-content-center">
              <img
                src={eventsData[event - 1].imgUrl}
                style={{ width: "100%", height: "auto", maxWidth: "600px", borderRadius: "12px" }}
                alt="Event"
              />
            </div>
            <div className="timer">
              {timer ? (
                <div className="timer-card">
                  <div>
                    <p
                      className="timer-card-time"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      {timer.days}
                    </p>
                    <p
                      className="timer-card-d"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      Days
                    </p>
                  </div>
                  <div>
                    <p
                      className="timer-card-time"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      {timer.hours}
                    </p>
                    <p
                      className="timer-card-d"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      Hours
                    </p>
                  </div>
                  <div>
                    <p
                      className="timer-card-time"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      {timer.minutes}
                    </p>
                    <p
                      className="timer-card-d"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      Min
                    </p>
                  </div>
                  <div>
                    <p
                      className="timer-card-time"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      {timer.seconds}
                    </p>
                    <p
                      className="timer-card-d"
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      Sec
                    </p>
                  </div>
                </div>
              ) : (
                <div className="time-end">
                  <div className="time-end-card">
                    <p
                      style={{
                        fontFamily: "Open Sans",
                      }}
                    >
                      {
                        getEventStatus(startDate, targetDate) === 1 ? 
                        "Ongoing Event" : "Completed Event"
                      } 
                      
                    </p>
                  </div>
                </div>
              )}
            </div>
            <div className="event-details">
              <div className="event-details-card">
                <h3 className="">Events Details</h3>
                <div className="event-details-card-details">
                  <div className="event-details-card-details-content">
                    <SlCalender className="events-details-icon" />{" "}
                    <p className="ms-2">{eventsData[event - 1].eventDate}</p>
                  </div>

                  <div className="d-flex justify-content-start ">
                    <FaRegClock className="events-details-icon" />{" "}
                    <p className="ms-2">{eventsData[event - 1].time}</p>
                  </div>

                  <div className="d-flex justify-content-start ">
                    <IoLocationOutline
                      className="events-details-icon"
                      style={{
                        fontSize: "1.2em",
                      }}
                    />
                    <p className="ms-2">{eventsData[event - 1].location}</p>
                  </div>

                  <div className="d-flex justify-content-start ">
                    <FaIndianRupeeSign className="events-details-icon" />{" "}
                    <p className="ms-2">{eventsData[event - 1].price}</p>
                  </div>
                </div>
                <p>{eventsData[event - 1].desc}</p>
                <div className="whatsapp-btn"> 
                  <a
                    href=" https://chat.whatsapp.com/BteZTyeTlnl1UrKNgc1i6g"
                    className="btn btn-lg rounded py-3 px-3"
                    style={{
                      width: "auto",
                      background: "#FCB541",
                      fontFamily: "Open Sans",
                      fontWeight: "500",
                      color: "black",
                    }}
                  >
                    Join Whatsapp group for updates
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Test2;
